import { PipeTransform, Pipe } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'termsFormater',
})
export class TermsFormaterPipe implements PipeTransform {
  constructor() {}

  transform(value: any) {
    const regex = /(#.*?\s?\(link:\s?.*?\))/g;
    const stringsLista = value.split('**');
    const apresentacao = stringsLista.shift();
    const termos = stringsLista.map(el => {
      el = '**' + el;

      let [titulo, texto] = el.split('\n');
      titulo = titulo.split(' ');
      titulo.shift(); // remove o primeiro valor, que nesse caso é vazio
      const ancora = titulo.shift();
      const textoTitulo = titulo.join(' ');
      texto = texto.replace(regex, (match: string, text: string) => {
          return this.createLink(text);
      });
      return `
      <div class="toggle-item">
      <h3 class="negrito display cursor-pointer" id="${ancora}">${textoTitulo}</h3>
      <p class="toggle text-justify">${texto}</p>
      </div>`;
    });
    return `<br><p class="text-justify">${apresentacao}</p><br><section>${termos.join('<br>')}</section>`;
  }

  private createLink(str: string) {
      return str.replace(
      /#+([A-Z]*.*)\s\(link:\s?(.*?)\)/,
        (match: string, texto: string, link: string, restante: string) => {
        return `<a class="link custom-link inline-block" href="/lista-de-termos#${link}">${texto}</a>`;
      },
    );
  }
}
